import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
// Copyright 2017-2022 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert, u8aToU8a } from '@polkadot/util'; // re-export the type so *.d.ts files don't have ../src imports

export function createDecode(_ref, validate) {
  var coder = _ref.coder,
      ipfs = _ref.ipfs;
  return function (value, ipfsCompat) {
    validate(value, ipfsCompat);
    return coder.decode(ipfs && ipfsCompat ? value.substring(1) : value);
  };
}
export function createEncode(_ref2) {
  var coder = _ref2.coder,
      ipfs = _ref2.ipfs;
  return function (value, ipfsCompat) {
    var out = coder.encode(u8aToU8a(value));
    return ipfs && ipfsCompat ? "".concat(ipfs).concat(out) : out;
  };
}
export function createIs(validate) {
  return function (value, ipfsCompat) {
    try {
      return validate(value, ipfsCompat);
    } catch (error) {
      return false;
    }
  };
}
export function createValidate(_ref3) {
  var chars = _ref3.chars,
      ipfs = _ref3.ipfs,
      type = _ref3.type;
  return function (value, ipfsCompat) {
    assert(value && typeof value === 'string', function () {
      return "Expected non-null, non-empty ".concat(type, " string input");
    });

    if (ipfs && ipfsCompat) {
      assert(value[0] === ipfs, function () {
        return "Expected ipfs-compatible ".concat(type, " to start with '").concat(ipfs, "'");
      });
    }

    var _loop = function _loop(i) {
      assert(chars.includes(value[i]) || value[i] === '=' && (i === value.length - 1 || !chars.includes(value[i + 1])), function () {
        return "Invalid ".concat(type, " character \"").concat(value[i], "\" (0x").concat(value.charCodeAt(i).toString(16), ") at index ").concat(i);
      });
    };

    for (var i = ipfsCompat ? 1 : 0; i < value.length; i++) {
      _loop(i);
    }

    return true;
  };
}